/*eslint react-hooks/exhaustive-deps: "off"*/
import React, { useCallback, useContext, useState } from "react";
import MapPropsContext from "../MapPropsContext";
import { Title } from "./Common";
import { Checkbox, Col, Input, Row } from "antd";
import StyledChekbox from "../../../styled-components/StyledChekbox";
import { TI_SELECT_ALL_CHECK_BOX } from "../../../Constants";

function CheckboxGroupWithCheckAll({ title, fieldName, options, colSpan }) {
  const { widgetState, onChangeWidgetState, iconDict } = useContext(MapPropsContext);
  const fieldValue = widgetState[fieldName];

  const [state, setState] = useState({
    indeterminate: fieldValue.length < options.length,
    checkAll: fieldValue.length === options.length,
  });

  const onCheckAllChange = useCallback(
    ({ target: { checked } }) => {
      setState({
        indeterminate: false,
        checkAll: checked,
      });
      onChangeWidgetState({
        target: {
          name: fieldName,
          value: !checked ? [] : options.map(({ value }) => value),
        },
      });
    },
    [options]
  );

  const onChange = useCallback(
    (checkedValues) => {
      setState({
        indeterminate: !!checkedValues.length && checkedValues.length < options.length,
        checkAll: checkedValues.length === options.length,
      });

      onChangeWidgetState({
        target: { name: fieldName, value: checkedValues },
      });
    },
    [onChangeWidgetState, setState, options]
  );

  return (
    <>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <h3>{title}</h3>
        <label>
          <StyledChekbox checked={state.checkAll} onChange={onCheckAllChange} tabIndex={TI_SELECT_ALL_CHECK_BOX} />
          <span style={{ marginLeft: 8 }}>전체 선택</span>
        </label>
      </div>
      {/* <Checkbox.Group
        name={fieldName}
        value={fieldValue}
        onChange={onChange}
        size={"small"}
        style={{ width: "100%" }}
      > */}
      <Row>
        {options.map(({ value, label, iconCode }, index) => {
          const { data, width, height } = iconDict[iconCode] || {};
          const iconWidth = 24;
          const ratio = iconWidth / width;
          const iconHeight = Math.floor(height * ratio);
          return (
            <Col span={colSpan} key={index}>
              <label>
                <StyledChekbox
                  checked={fieldValue.includes(value)}
                  onChange={() => {
                    // console.log(widgetState,/ fieldValue);
                    let checkedValues = [...fieldValue];
                    const findIndex = checkedValues.indexOf(value);
                    if (findIndex === -1) {
                      checkedValues.push(value);
                    } else {
                      checkedValues = checkedValues.filter((checkedValue) => checkedValue !== value);
                    }
                    onChange(checkedValues);
                  }}
                  tabIndex={TI_SELECT_ALL_CHECK_BOX + 1 + index}
                />
                {data ? (
                  <img
                    alt={label}
                    src={data}
                    style={{
                      width: iconWidth,
                      height: iconHeight,
                      marginLeft: 8,
                      marginRight: 4,
                    }}
                  />
                ) : (
                  <span style={{ marginRight: 4 }}></span>
                )}
                {label}
              </label>
              {/* <Checkbox value={value}>
                  {data && (
                    <img
                      src={data}
                      style={{
                        width: iconWidth,
                        height: iconHeight,
                        marginRight: 4,
                      }}
                      alt={""}
                    />
                  )}
                  {label}
                </Checkbox> */}
            </Col>
          );
        })}
      </Row>
      {/* </Checkbox.Group> */}
    </>
  );
}

export default CheckboxGroupWithCheckAll;
